import React, { createContext, useContext, useState } from "react";

// Define context type
interface LogTypeContextType {
  logtype: string;
  setLogtype: React.Dispatch<React.SetStateAction<string>>;
}

// Create context with default values
const LogTypeContext = createContext<any>(undefined);

// Provider component
export const LogTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [logtype, setLogtype] = useState<string>("SystemUser");
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [isVerifyModalVisible, setIsVerifyModalVisible] = useState(false);
  

  return (
    <LogTypeContext.Provider
     value={{ logtype, setLogtype,isResendOtp, setIsResendOtp,isVerifyModalVisible, setIsVerifyModalVisible }}
     >
      {children}
    </LogTypeContext.Provider>
  );
};

// Custom hook to use the LogType context
export const useLogType = () => {
  const context = useContext(LogTypeContext);
  if (!context) {
    throw new Error("useLogType must be used within a LogTypeProvider");
  }
  return context;
};
